import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './redux/index';
import { baseApi } from './redux/api/baseApi';

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export default store;